import { gql } from '@apollo/client';

export const INSERT_USER_ROLE = gql`
  mutation insert_user_role($objects: [user_role_insert_input!]!) {
    insert_user_role(objects: $objects) {
      affected_rows
    }
  }
`;

export const USER_ROLE_LIST = gql`
  subscription user_role_list($where: user_role_bool_exp, $order_by: [user_role_order_by!]) {
    user_role(where: $where, order_by: $order_by) {
      id
      name
      systemRole
      department {
        name
      }
    }
  }
`;

export const USER_ROLE_LIST_FOR_USER_PERMISSIONS_FORM = gql`
  query user_role_list_for_user_permissions_form($where: user_role_bool_exp, $order_by: [user_role_order_by!]) {
    user_role(where: $where, order_by: $order_by) {
      id
      name
      systemRole
    }
  }
`;

export const DELETE_USER_ROLE = gql`
  mutation delete_user_role($where: user_role_bool_exp!) {
    delete_user_role(where: $where) {
      affected_rows
    }
  }
`;

export const USER_ROLE = gql`
  query user_role($where: user_role_bool_exp) {
    user_role(where: $where) {
      name
      departmentId
      systemRole
      user_role_routes_routes {
        route {
          id
          name
          iconName
          global
        }
      }
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation update_user_role($_set: user_role_set_input, $where: user_role_bool_exp!) {
    update_user_role(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const DELETE_USER_ROLE_ROUTES = gql`
  mutation delete_user_role_routes($where: user_role_routes_route_bool_exp!) {
    delete_user_role_routes_route(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_USER_ROLE_ROUTES = gql`
  mutation insert_user_role_routes($objects: [user_role_routes_route_insert_input!]!) {
    insert_user_role_routes_route(objects: $objects) {
      affected_rows
    }
  }
`;
